import request from "@/shared/config/request";
import { ENDPOINTS } from "@/shared/constants/api";
import { accessToken } from "@/shared/types/auth";
import { User } from "@/shared/types/user";

export async function getMe(): Promise<User> {
  return await request
    .get<User>(ENDPOINTS.GET_ME)
    .then((response) => response.data);
}

export async function refreshToken({
  refreshToken,
}: {
  refreshToken: string;
}): Promise<accessToken> {
  return await request
    .post<accessToken>(ENDPOINTS.REFRESH_TOKEN, { refreshToken })
    .then((res) => res.data);
}
